import * as React from "react";

export const Users = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill={props.color || '#51A2B5'}
      d="M13.5 0a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM6 1a4 4 0 0 0 0 8c.83 0 1.587-.228 2.253-.694-1.709-2.54-1.467-4.972-.535-6.931A3.995 3.995 0 0 0 6 1Zm-2.938 9.344C1.228 11.101 0 12.956 0 15v2a1 1 0 0 0 1 1l4.153.002c-.234-.76-.165-1.992-.15-2.989.032-2.117.908-3.627 1.25-4.025a5.464 5.464 0 0 1-1.94-.394c-.135-.057-.212-.102-.47-.219a.964.964 0 0 0-.78-.031Zm7 0C8.229 11.101 7 12.956 7 15v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2c0-1.996-1.235-3.806-3.063-4.594a1.02 1.02 0 0 0-.812 0c-.885.397-1.747.594-2.625.594-.875 0-1.74-.208-2.656-.625a.964.964 0 0 0-.781-.031Z"
    />
  </svg>
);

export default Users;
